import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Taxonomy from './components/Taxonomy';
import Scenarios from './components/Scenarios';
import Products from './components/Products';
import Accessories from './components/Accessories';
import CompareTable from './components/CompareTable';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />
      <main>
        <Hero />
        <Taxonomy />
        <Scenarios />
        <Products />
        <Accessories />
        <CompareTable />
      </main>
      <Footer />
    </div>
  );
}